import { Select as MuiSelect } from '@mui/material';
import { styled, lighten } from '@mui/material/styles';

export const StyledSelect = styled(MuiSelect)(({ theme, size }: { theme: any; size?: 'small' | 'medium' }) => ({
  '&.Mui-disabled': {
    backgroundColor: '#F2F4F7 !important',
  },
  '&.Mui-disabled.Mui-error': {
    backgroundColor: '#F2F4F7 !important',
  },
  '& .MuiInputBase-root.Mui-disabled': {
    border: '1px solid #D0D5DD',
    borderRadius: '8px !important',
    backgroundColor: 'transparent',
    padding: 0,
    '& .MuiSelect-select': {
      borderRadius: '8px !important',
      backgroundColor: '#F2F4F7 !important',
      padding: size === 'medium' ? '12px' : '8px',
    },
    '& .MuiOutlinedInput-input': {
      backgroundColor: '#F2F4F7 !important',
    },
  },
  '&.Mui-disabled .MuiSelect-select': {
    backgroundColor: '#F2F4F7 !important',
  },
  '& .MuiInputBase-root.Mui-error': {
    borderColor: '#FDA29B',
    '& .MuiSelect-select': {
      borderColor: '#FDA29B',
    },
  },
  '& .MuiInputBase-root': {
    paddingLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    '&:before, &:after': {
      display: 'none',
    },
    backgroundColor: '#ffffff',
    borderRadius: '8px !important',
    border: '1px solid #D0D5DD',
    transition: 'box-shadow 0.2s ease-in-out',
    '&:focus-within': {
      boxShadow: `0 0 0 1px ${lighten(theme.palette.primary.main, 0.4)}, 0 0 0 4px ${lighten(
        theme.palette.primary.main,
        0.8,
      )}`,
      '&.Mui-error': {
        boxShadow: `0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(240, 68, 56, 0.24)`,
      },
      backgroundColor: '#fff',
      outline: 'none',
      borderRadius: '8px !important',
    },
    '&.Mui-focused': {
      backgroundColor: '#ffffff !important',
      borderRadius: '8px !important',
    },
  },
  '&.Mui-focused': {
    borderRadius: '8px !important',
    boxShadow: `0 0 0 1px ${lighten(theme.palette.primary.main, 0.4)}, 0 0 0 4px ${lighten(
      theme.palette.primary.main,
      0.8,
    )}`,
    '&.Mui-error': {
      boxShadow: `0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(240, 68, 56, 0.24)`,
    },
  },

  '& .MuiSelect-select': {
    borderRadius: '8px !important',
    padding: size === 'medium' ? '12px' : '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    backgroundColor: '#ffffff',
    minWidth: '120px',
    // If the individual items have icons, we need to align the items
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  '& .MuiInputAdornment-root': {
    marginTop: '0 !important',
    marginLeft: '12px',
    marginRight: '0px',
  },
  '& .MuiInputAdornment-positionStart': {
    marginLeft: '0 !important',
    marginRight: '0 !important',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: '2px',
  },
  '&.MuiSelect-root': {
    paddingLeft: '0',
    paddingRight: '0',
  },
  '& .MuiSelect-icon': {
    color: '#A4A7AE',
    marginRight: '2px',
  },
}));
